// @flow
import React, { useEffect, useState } from "react";
import CorrelationWorker from "./../../../../../custom-lib/correlation_worker.js";
import { Icon, IconClose } from "../../../base/icons";
import WebWorker from "./../../../../../custom-lib/workerSetup";

// css
import "./white-board.css";
import { getBaseConfig } from "../../Utils.js";
import { CURRENT_ROOM_LOCATION, CURRENT_ROOM_NAME, Constant } from "../../../webjam/constant/index.js";
import { getLJsonStorage } from "../../welcome-dashboard/Utils.js";
import { i18next } from "../../../base/i18n/index";
import { ct } from "../../constant-Utils";


const Whiteboard = (props) => {
    const { socket, Sessions, closeTool, mediaDetail } = props;
    // hide buttons and cross buttons
    const [isDisable, setIsDisable] = useState(false);

    const { openByUser, SessionId } = Sessions;

    // getting the web worker output here
    const interpret_correlation_result = event => {
        // student can able to send to techer
        socket.emit("white-board", {
            room: CURRENT_ROOM_LOCATION,
            openTool: "white-board"
        });

        // emit data for newly opened user
        socket.emit("openTools_fromtool", {
            openTool: "white-board",
            SessionId: Sessions.openByUser,
            location: CURRENT_ROOM_LOCATION,
            mediaDetail
        });
    };

    // added web workers for new thread
    const correlation_worker = new WebWorker(CorrelationWorker);

    // message Event
    correlation_worker.addEventListener(
        "message",
        interpret_correlation_result
    );

    useEffect(() => {

        if (SessionId === openByUser) {
            setIsDisable(true);
            socket.emit("openTools_fromtool", {
                openTool: "white-board",
                SessionId: Sessions.openByUser,
                location: CURRENT_ROOM_LOCATION,
                mediaDetail
            });
        } else {
            //setIsDisable(true);
            socket.on("white-board_return", function (data) {
                const { location } = data;
                if (location === CURRENT_ROOM_LOCATION) {
                }
            });
        }

        return function cleanup() {
            socket.off("white-board_return");
        };
    }, [openByUser]);

    useEffect(() => {
        setTimeout(function () {
            let frameId = document.getElementById("frame_id");
            if (frameId) {
                frameId.contentWindow.focus();
                console.log("document focused")
            } else {
                console.log("document focused false")
            }
        }, 5000)
    }, [])

    let url = getBaseConfig("whiteBoardUrl") + "/s/";
    let path = CURRENT_ROOM_NAME.replace("-", "");
    // path += "-white-board";
    path += "-Untitled-Space";

    let src = url + path;

    let winWidth = window.innerWidth - 140;
    let winHeight = window.innerHeight - 140;
    console.log("mediaDetail", mediaDetail);
    if (mediaDetail) {
        const searchParams = new URLSearchParams();
        Object.keys(mediaDetail).forEach(key => searchParams.append(key, mediaDetail[key]));
        src = src + "?" + searchParams.toString();
        if (winWidth > 700) {
            src = src + "&" + ("width=" + winWidth)
        }

        if (winHeight > 400) {
            src = src + "&" + ("height=" + winHeight)
        }
    }

    let willScreenShot = getBaseConfig("whiteboardScreenShot");

    if (willScreenShot == true) {
        if (src.includes("&")) {
            src = src + "&screenshotAllow=true";
        } else {
            src = src + "?screenshotAllow=true";
        }
    }

    let currentLanguage: string = i18next.language;

    if (currentLanguage) {
        src = src + "&_lang=" + currentLanguage
    }

    const isGuestAccount = getLJsonStorage("auth", "guest_id");

    return (
        <div className="whiteboardpage">
            {isGuestAccount ? "" : <div id="whiteboard-close-icon-wrapper" className="close-side-bar" onClick={closeTool}>
                <Icon containerId="whiteboard-close-icon" src={IconClose} />
            </div>}
            <h1 id="note-name">{ct("rta-trmc.tools.toolName.whiteboard")}</h1>
            <iframe
                className="whiteboardiframe"
                src={src}
                name="iframe_whiteboard"
                title={ct("rta-trmc.toolBox.whiteboard")}
                id="frame_id"

            ></iframe>
        </div >
    );
};

export default Whiteboard;
